module.exports = __webpack_public_path__ + "static/media/Mauritius.b2004df9.png";